<template>
  <div class="group flex items-center gap-2">
    <!-- Hidden Native Radio Input -->
    <input
      type="checkbox"
      class="peer hidden hidden!"
      :id="id"
      :name="name"
      :checked="modelValue"
      @change="$emit('update:modelValue', $event.target.checked)"
      :disabled="disabled"
    />

    <!-- Custom Radio Button -->
    <div
      class="flex cursor-pointer items-center justify-center rounded border border-solid focus:outline focus:outline-2 focus:outline-offset-2 focus:outline-turquoise-40 group-hover:border-turquoise-40 group-hover:bg-turquoise-10"
      :class="[
        {
          'border-gray': !!disabled,
          'border-turquoise-40 bg-turquoise-60': !!modelValue,
          'border-turquoise-60 bg-turquoise-10': !disabled,
        },
        sizeClasses.radio,
      ]"
      @click="!disabled && $emit('update:modelValue', !modelValue)"
      @keyup.enter="!disabled && $emit('update:modelValue', !modelValue)"
      :aria-checked="!!modelValue"
      tabindex="0"
      role="radio"
    >
      <div
        class="transition-all duration-200 group-hover:bg-turquoise-10 group-hover:text-turquoise-60"
        :class="[
          {
            'scale-100 bg-turquoise-60 text-white': modelValue === true,
            'scale-0 bg-transparent text-white': modelValue === false,
          },
        ]"
      >
        <IconCheckmark size="12" />
      </div>
    </div>

    <!-- Label -->
    <label
      v-if="label"
      :for="id"
      class="cursor-pointer transition-all text-b2"
      :class="[sizeClasses.label, disabled ? 'text-gray-400' : 'text-gray-700']"
      tabindex="0"
      @keyup.enter="$emit('update:modelValue', !modelValue)"
    >
      {{ label }}
    </label>
  </div>
</template>

<script>
import IconCheckmark from '@/components/icons/IconCheckmark';

export default {
  name: 'CheckboxButton',
  components: { IconCheckmark },
  props: {
    id: { type: String, required: true },
    name: { type: String, required: true }, // Radios in the same group should have the same name
    label: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    modelValue: { type: Boolean, default: false }, // Add missing modelValue prop
    size: {
      type: String,
      default: 'md',
      validator: (value) => ['sm', 'md', 'lg'].includes(value),
    },
    customIcon: { type: String, default: '' },
  },
  emits: ['update:modelValue'],
  computed: {
    sizeClasses() {
      const sizes = {
        sm: { radio: 'w-4 h-4', label: 'text-sm', icon: 'text-xs' },
        md: {
          radio: 'w-[18px] h-[18px]',
          label: 'text-base',
          icon: 'text-sm',
        },
        lg: { radio: 'w-6 h-6', label: 'text-lg', icon: 'text-base' },
      };
      return sizes[this.size] || sizes.md;
    },
  },
};
</script>
